import React, { useState, useEffect, useContext } from 'react';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import Alert from 'react-s-alert';
import { ThemeContext } from '../../contexts/ThemeContext';
import { PsychometricContext } from '../../contexts/PsychometricContext';
import PsychometricOrganizationNavbar from './PyschometricOrganizationNavbar';
import Footer from '../general/Footer';
import PsychometricService from '../../services/PsychometricService';
import { FaInfoCircle } from 'react-icons/fa';

const PyschometricOrganizationHomePage = props => {
   
    const { theme } = useContext(ThemeContext);
    const { signedEmail, signedPassword, signedOrganization } = useContext(PsychometricContext); 

    // states
    const [organization, setOrganization] = useState({
        name: '',
        email: '',
        address: '',
        city: '',
        state: '',
        country: '',
        website: '',
        isStudent: true,
        isPrivate: false,
    });

    const [modal, setModal] = useState(false); 
    const toggleModal = () => setModal(!modal); 

    // Add new state for privacy info modal
    const [privacyInfoModal, setPrivacyInfoModal] = useState(false);
    const togglePrivacyInfoModal = () => setPrivacyInfoModal(!privacyInfoModal);

    // Add new state for privacy warning modal
    const [privacyWarningModal, setPrivacyWarningModal] = useState({
        isVisible: false,
        pendingChanges: null
    });
    const [publicWarningModal, setPublicWarningModal] = useState({
        isVisible: false,
        pendingChanges: null
    });
    useEffect(() => {
        // Check both context and sessionStorage
        const storedEmail = sessionStorage.getItem('signedEmail');
        const storedOrg = sessionStorage.getItem('signedOrganization');
        const emailToUse = signedEmail || storedEmail;
        const orgToUse = signedOrganization || storedOrg;


        
        if (!orgToUse || !emailToUse) {
            console.log('No organization or email found, redirecting...');
            props.history.replace('/psychometricSignIn');
            return;
        }

        // Store the values in sessionStorage if they exist in context
        if (signedEmail) sessionStorage.setItem('signedEmail', signedEmail);
        if (signedOrganization) sessionStorage.setItem('signedOrganization', signedOrganization);

        // Fetch organization details
        PsychometricService.getPsychometricOrganization(emailToUse)
            .then(data => {
             
                const orgData = data.user || data; 

                setOrganization({
                    name: orgData.name || '',
                    email: orgData.email || '',
                    address: orgData.address || '',
                    city: orgData.city || '',
                    state: orgData.state || '',
                    country: orgData.country || '',
                    website: orgData.website || '',
                    isStudent: orgData.isStudent !== undefined ? orgData.isStudent : true,
                    isPrivate: orgData.isPrivate !== undefined ? orgData.isPrivate : false,
                });

            
            })
            .catch(err => {
                console.error('Error fetching organization details:', err);
                // If there's an error fetching details, might want to redirect
                props.history.replace('/psychometricSignIn');
            });
    }, [signedEmail, signedOrganization]);

   
    const handleUpdate = async () => {
     
        // Get the current organization details before update
        const currentOrgDetails = await PsychometricService.getPsychometricOrganization(organization.email);
        const isCurrentlyPrivate = currentOrgDetails.user.isPrivate;
        // Check if switching from private to public
        const isGoingPublic = isCurrentlyPrivate && !organization.isPrivate;
        // Check if switching from public to private
        const isGoingPrivate = !isCurrentlyPrivate && organization.isPrivate;
        
        if (isGoingPrivate) {
            setPrivacyWarningModal({
                isVisible: true,
                pendingChanges: organization
            });
            return;
        }
        if (isGoingPublic) {
            setPublicWarningModal({
                isVisible: true,
                pendingChanges: organization
            });
            return;
        }
        // Normal update if not changing privacy setting
        try {
            await PsychometricService.updateOrganizationByDetails(
                organization.name, 
                organization.email, 
                organization
            );
            Alert.success("Organization updated successfully");
            toggleModal();
        } catch (err) {
            console.error('Error updating organization:', err);
            Alert.error("Failed to update organization");
        }
    };

    const handlePrivacyConfirm = async () => {
        try {
            // Update organization first
            await PsychometricService.updateOrganizationByDetails(
                privacyWarningModal.pendingChanges.name,
                privacyWarningModal.pendingChanges.email,
                privacyWarningModal.pendingChanges
            );

            // Remove emails for all candidates
            await PsychometricService.handleOrganizationPrivacy(
                privacyWarningModal.pendingChanges.name,
                'remove'
            );

            Alert.success("Organization updated successfully");
            setPrivacyWarningModal({ isVisible: false, pendingChanges: null });
            toggleModal();
        } catch (error) {
            console.error('Error updating organization privacy:', error);
            Alert.error("Failed to update organization");
        }
    };
    const handlePublicConfirm = async () => {
        try {
            await PsychometricService.updateOrganizationByDetails(
                publicWarningModal.pendingChanges.name,
                publicWarningModal.pendingChanges.email,
                publicWarningModal.pendingChanges
            );
            Alert.success("Organization updated successfully");
            setPublicWarningModal({ isVisible: false, pendingChanges: null });
            toggleModal();
        } catch (error) {
            console.error('Error updating organization privacy:', error);
            Alert.error("Failed to update organization");
        }
    };
    // Handle input changes in the modal
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setOrganization(prevOrg => ({
            ...prevOrg,
            [name]: name === 'isStudent' || name === 'isPrivate' ? value === 'true' : value
        }));
    };

    return (
        <div>
            <PsychometricOrganizationNavbar />
            <hr style={{ margin: '20px 0' }} />
            <div id="organizationProfileDiv" className="px-3 py-5 container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <h2 id="organizationProfile" style={{ ...theme.heading, marginBottom: '20px', textAlign: 'center' }}>Organisation Profile</h2>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Company Name:</strong></Col>
                            <Col md={8}>{organization.name}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Email:</strong></Col>
                            <Col md={8}>{organization.email}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Address:</strong></Col>
                            <Col md={8}>{organization.address}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>City:</strong></Col>
                            <Col md={8}>{organization.city}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>State:</strong></Col>
                            <Col md={8}>{organization.state}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Country:</strong></Col>
                            <Col md={8}>{organization.country}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Website:</strong></Col>
                            <Col md={8}>{organization.website}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Test Type:</strong></Col>
                            <Col md={8}>{organization.isStudent ? 'Student' : 'Corporate'}</Col>
                        </Row>
                        <Row style={{ marginBottom: '20px' }}>
                            <Col md={4}><strong>Data Privacy:</strong></Col>
                            <Col md={8}>
                                {organization.isPrivate ? 'Private' : 'Public'}
                                <FaInfoCircle 
                                    className="ms-3" 
                                    style={{ cursor: 'pointer' }}
                                    onClick={togglePrivacyInfoModal}
                                />
                            </Col>
                        </Row>
                        <div className="text-center">
                            <Button id="editBtn" style={theme.button} onClick={toggleModal}>
                                Edit Profile
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Privacy Info Modal */}
            <Modal isOpen={privacyInfoModal} toggle={togglePrivacyInfoModal}>
                <ModalHeader toggle={togglePrivacyInfoModal}>Data Privacy Settings</ModalHeader>
                <ModalBody>
                    <h5>Public Data (Default)</h5>
                    <ul>
                        
                        <li>You are opting to <b>ALLOW</b> Umang Wellness to store your organization's candidate's email addresses</li>
                        <li>We will use this data to send them test invitations</li>
                        <li>We will provide you with a unique code for each candidate upon their creation</li>
                    </ul>
                    
                    <h5>Private Data</h5>
                    <ul>
                    <li>You are opting to <b>NOT ALLOW</b> us to use your organization's candidate's email addresses</li>
                    <li>You will be responsible for providing your candidates with a unique code to access the test</li>
                    </ul>
                    

                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={togglePrivacyInfoModal}>Close</Button>
                </ModalFooter>
            </Modal>

            {/* Modal for editing profile */}
            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Edit Organisation Profile</ModalHeader>
                <ModalBody>
                    <div>Company Name: </div>
                    <Input name="name" value={organization.name} onChange={handleInputChange} placeholder="Company Name" />
                    <div>Email: </div>
                    <Input name="email" value={organization.email} onChange={handleInputChange} placeholder="Email" />
                    <div>Address: </div>
                    <Input name="address" value={organization.address} onChange={handleInputChange} placeholder="Address" />
                    <div>City: </div>
                    <Input name="city" value={organization.city} onChange={handleInputChange} placeholder="City" />
                    <div>State: </div>
                    <Input name="state" value={organization.state} onChange={handleInputChange} placeholder="State" />
                    <div>Country: </div>
                    <Input name="country" value={organization.country} onChange={handleInputChange} placeholder="Country" />
                    <div>Website: </div>
                    <Input name="website" value={organization.website} onChange={handleInputChange} placeholder="Website" />
                    <div>Test Type: </div>
                    <Input 
                        type="select" 
                        name="isStudent" 
                        value={organization.isStudent} 
                        onChange={handleInputChange}
                    >
                        <option value={true}>Student</option>
                        <option value={false}>Corporate</option>
                    </Input>
                    <div>Data Privacy Setting: <FaInfoCircle 
                        className="ms-3" 
                        style={{ cursor: 'pointer' }}
                        onClick={togglePrivacyInfoModal}
                    /></div>
                    <Input 
                        type="select" 
                        name="isPrivate" 
                        value={organization.isPrivate} 
                        onChange={handleInputChange}
                    >
                        <option value={true}>Private Data</option>
                        <option value={false}>Public Data</option>
                    </Input>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary"  style={theme.button} onClick={handleUpdate}>Save Changes</Button>{' '}
                    <Button color="secondary"  style={theme.button} onClick={toggleModal}>Cancel</Button>
                </ModalFooter>
            </Modal>

            {/* Privacy Warning Modal */}
            <Modal 
                isOpen={privacyWarningModal.isVisible} 
                toggle={() => setPrivacyWarningModal({ isVisible: false, pendingChanges: null })}
            >
                <ModalHeader toggle={() => setPrivacyWarningModal({ isVisible: false, pendingChanges: null })}>
                    Privacy Setting Change Warning
                </ModalHeader>
                <ModalBody>
                    <div className="alert alert-warning">
                        <h5>Important Notice</h5>
                        <p>Switching to private mode will require you to provide unique codes for all candidates as we will not be able to use their email addresses.</p>
                        <p> Do you want to proceed? If you change it back to public mode, you will be able to retain your existing email addresses for each candidate.</p>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={theme.button}
                        color="danger"
                        onClick={handlePrivacyConfirm}
                    >
                        Proceed
                    </Button>
                    <Button
                        style={theme.button}
                        color="secondary"
                        onClick={() => setPrivacyWarningModal({ isVisible: false, pendingChanges: null })}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
                     <Modal 
               isOpen={publicWarningModal.isVisible} 
               toggle={() => setPublicWarningModal({ isVisible: false, pendingChanges: null })}
           >
               <ModalHeader toggle={() => setPublicWarningModal({ isVisible: false, pendingChanges: null })}>
                   Privacy Setting Change Warning
               </ModalHeader>
               <ModalBody>
                   <div className="alert alert-warning">
                       <h5>Important Notice</h5>
                       <p>Switching to public mode means:</p>
                       <ul>
                           <li>You will need to provide email addresses for all new candidates</li>
                           <li>Email addresses will be stored in our system</li>
                           <li>Candidates will receive test invitations via email</li>
                      
                    </ul>
                    <p>Do you want to proceed?</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    style={theme.button}
                        color="warning"
                        onClick={handlePublicConfirm}
                    >
                        Proceed
                    </Button>
                    <Button
                        style={theme.button}
                        color="secondary"
                        onClick={() => setPublicWarningModal({ isVisible: false, pendingChanges: null })}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default PyschometricOrganizationHomePage;
